
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderPromoDialog extends Serenity.EntityDialog<ECommOrderPromoRow, any> {
        protected getFormKey() { return ECommOrderPromoForm.formKey; }
        protected getIdProperty() { return ECommOrderPromoRow.idProperty; }
        protected getLocalTextPrefix() { return ECommOrderPromoRow.localTextPrefix; }
        protected getService() { return ECommOrderPromoService.baseUrl; }
        protected getDeletePermission() { return ECommOrderPromoRow.deletePermission; }
        protected getInsertPermission() { return ECommOrderPromoRow.insertPermission; }
        protected getUpdatePermission() { return ECommOrderPromoRow.updatePermission; }

        protected form = new ECommOrderPromoForm(this.idPrefix);

    }
}